import React from "react"
import { Label } from "ui/components/atoms/typography"
import { BaseStyles } from "ui/types/base-styles"
import { generateStylesFromProps } from "ui/utils/styles"

import styles from "./List.module.css"

const List = ({
  list,
  className = "",
  style = {},
  ...rest
}: BaseStyles & {
  list: string[]
  className?: string
  style?: React.CSSProperties
}) => {
  const generatedStyles = generateStylesFromProps(rest)

  const wrapperStyles = {
    ...generatedStyles,
    ...style,
  }

  return (
    <div className={`${styles.wrapper} ${className}`} style={wrapperStyles}>
      {list.map((el, index) => (
        <Label key={index} icon="check" $iconColor="primary" $type="secondary">
          {el}
        </Label>
      ))}
    </div>
  )
}

export default List
